export default __webpack_public_path__ + "static/media/facebook.76813e87.svg";